<template>
  <div>
    <v-dialog
      v-model="showEditForm"
      persistent
      fullscreen
    >
      <div class="content-section">
        <h1 class="header-style">
          Worker Details
        </h1>
        <v-form
          ref="form"
          v-model="isFormValid"
          class="mt-6"
          lazy-validation
        >
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="firstName"
                label="First Name*"
                dense
                :rules="[(v) => !!v || 'This field is required']"
                filled
                color="#000000"
                light
                outlined
                background-color="#FFF"
                class="purple-input"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="lastName"
                label="Last Name*"
                filled
                :rules="[(v) => !!v || 'This field is required']"
                color="#000000"
                dense
                outlined
                background-color="#FFF"
                light
                class="purple-input"
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="phoneNumber"
            label="Phone number"
            filled
            color="#000000"
            outlined
            background-color="#FFF"
            dense
            persistent-hint
            light
            disabled
            class="purple-input"
            type="number"
          />
          <v-text-field
            v-model="email"
            label="Email"
            filled
            color="#000000"
            outlined
            background-color="#FFF"
            dense
            persistent-hint
            light
            class="purple-input"
          />
          <v-text-field
            v-model="company"
            light
            color="#37474F"
            flat
            dense
            label="Company"
            outlined
            background-color="#FFF"
            disabled
            class="small-select"
          />
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="selectedCheckinType"
                light
                color="black"
                flat
                dense
                :items="chekinTypes"
                item-text="name"
                item-value="id"
                label="Checkin Type"
                outlined
                background-color="#FFF"
                class="small-select checkin"
                multiple
                :disabled="checkRequestStatus || signUpUser"
                :rules="[(v) => v.length > 0 || 'This field is required']"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="workerCategories"
                light
                color="black"
                flat
                dense
                :items="workerCatergoy"
                item-text="name"
                item-value="id"
                label="Worker Category"
                outlined
                background-color="#FFF"
                class="small-select checkin"
                :disabled="checkRequestStatus || isWorkerSelected || !signUpUser"
                :rules="isWorkerSelected ? [] : [(v) => !!v || 'This field is required']"
              />
            </v-col>
          </v-row>
          <v-select
            v-model="country"
            light
            color="#37474F"
            flat
            dense
            :items="countriesListing"
            item-text="value"
            item-value="key"
            label="Country"
            outlined
            background-color="#FFF"
            class="small-select"
            :disabled="checkRequestStatus || signUpUser"
            :rules="[(v) => !!v || 'This field is required']"
          />
          <v-switch
            v-model="highRiskWorker"
            persistent-hint
            color="#37474F"
            :disabled="isWorkerSelected"
          >
            <template #label>
              <span>High Risk Worker</span>
            </template>
          </v-switch>
          <p class="hint-text">
            User works under high risk category
          </p>
        </v-form>
        <v-btn
          v-if="appUserDetails.created_by ==='sign-up'"
          class="btn-style"
          color="#64CA7F"
          elevation="0"
          @click="approveWorker"
        >
          Approve
        </v-btn>
        <v-btn
          v-if="appUserDetails.created_by !=='sign-up'"
          class="btn-style"
          color="#64CA7F"
          elevation="0"
          @click="updateWorker"
        >
          Update
        </v-btn>
        <v-btn
          class="btn-style grey-button"
          color="#E2E2E2"
          elevation="0"
          @click="showEditForm = false"
        >
          Cancel
        </v-btn>
        <v-btn
          fab
          color="#FFF"
          small
          rounded
          elevation="0"
          class="close-button"
          @click="showEditForm = false"
        >
          <v-icon color="#37474f">
            mdi mdi-close
          </v-icon>
        </v-btn>
      </div>
      <centre-spinner :loading="loading" />
    </v-dialog>
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
export default {
  name: 'AppUserEditForm',
  components: {
    'centre-spinner': spinner,
  },
  props: {
    orgExternalId: {
      type: String,
      default: null,
    },
    appuserId: {
      type: String,
      default: null,
    },
    appUserRole: {
      type: String,
      default: null,
    },
    selectedReqStatus: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      role: '',
      company: '',
      companyContractor: '',
      workerCategories: '',
      country: '',
      selectedCheckinType: [],
      valid: false,
      showEditForm: true,
      orgDetails: [],
      highRiskWorker: false,
      chekinTypes: [
        {
          name: 'Worker',
          id: 'worker',
        },
        {
          name: 'Visitor',
          id: 'visitor',
        },
      ],
      isFormValid: false,
      loading: false,
    };
  },
  computed: {
    signUpUser () {
      return this.appUserDetails.created_by === 'sign-up';
    },
    phoneNumberRules () {
      return [
        (v) => !!v || 'This field is required',
        (v) => (v && v.length <= 15) || 'Phone number exceeded the limit.',
      ];
    },
    appUserDetails () {
      return this.$store.getters['appusers/getAppUserDetails'];
    },
    workerCatergoy () {
      return this.$store.getters['organization/getWorkerCategories'];
    },
    countriesList () {
      return this.$store.getters['countries/getCountries'];
    },
    CountryZipCodeList () {
      return this.$store.getters['countries/getCountries'];
    },
    countriesListing () {
      return Object.keys(this.CountryZipCodeList).map((key) => ({
        text: this.CountryZipCodeList[key],
        value: this.CountryZipCodeList[key],
      }));
    },
    isWorkerSelected () {
      if (this.selectedCheckinType.includes('worker')) {
        return false;
      }
      return true;
    },
    validationRules () {
      if (this.selectedCheckinType.includes('worker')) {
        return [(v) => !!v || 'This field is required'];
      } else {
        return [];
      }
    },
    //  roleBasedButton () {
    //    if (this.appUserRole === 'contractor') {
    //      return 'Update';
    //    } else if (this.appUserRole === 'site-manager' && this.selectedReqStatus === 'pending') {
    //      return 'Update';
    //    }
    //    return 'Accept';
    // },
    checkRequestStatus () {
      if (this.appUserDetails.request_status === 'pending') {
        return false;
      }
      return true;
    },
  },
  watch: {
    isWorkerSelected (newVal) {
      if (newVal) {
        this.workerCategories = '';
        this.highRiskWorker = false;
      }
    },
    showEditForm: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },

  async mounted () {
    this.loading = true;
    await this.getAppUserDetails();
    await this.getWorkerCategory();
    await this.getUserCountries();
    this.loading = false;
  },

  methods: {
    async getAppUserDetails () {
      await this.$store.dispatch('appusers/fetchAppUserDetails', {
        externalId: this.orgExternalId,
        id: this.appuserId,
      }).then(() => {
        this.firstName = this.appUserDetails.first_name;
        this.lastName = this.appUserDetails.last_name;
        this.phoneNumber = this.appUserDetails.phone_number;
        this.email = this.appUserDetails.email;
        this.company = this.appUserDetails.company.name;
        this.selectedCheckinType = this.appUserDetails.types;
        this.workerCategories = this.appUserDetails.worker_category !== null ? this.appUserDetails.worker_category.id : null;
        this.country = this.appUserDetails.country_code;
        this.role = this.appUserDetails.app_user_role;
        this.highRiskWorker = this.appUserDetails.high_risk_worker;
      });
    },
    async getWorkerCategory () {
      this.$store.dispatch('organization/fetchWorkerCategories', {
        externalId: this.orgExternalId,
      });
    },
    async getUserCountries () {
      await this.$store.dispatch('countries/fetchCountries');
    },
    async updateWorker () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.loading = true;
      await this.$store
        .dispatch('appusers/updatePendingAppUser', {
          details: {
            first_name: this.firstName,
            high_risk_worker: this.highRiskWorker,
            last_name: this.lastName,
            email: this.email,
            user_role: this.role,
            worker_category_id: this.workerCategories,
            types: this.selectedCheckinType,
            country_code: this.country,
          },
          orgExternalId: this.orgExternalId,
          appUserExtId: this.appuserId,
        })
        .then((response) => {
          this.loading = false;
          this.showEditForm = false;
          this.$refs.form.reset();
          this.$store.dispatch(
            'alert/onAlert',
            {
              message: this.appUserRole === 'site-manager' ? 'Approved Successfully!' : 'Updated Successfully',
              type: Constants.ALERT_TYPE_SUCCESS,
            },
            { root: true },
          );
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async approveWorker () {
      await this.$store.dispatch('appusers/updateAppUserStatus', {
        appUserOrganizationId: this.appUserDetails.app_user_organization_id,
        status: {
          request_status: 'accepted',
        },
      });
      await this.$store
        .dispatch('appusers/clearPendingAppUsersList')
        .then(() => {
          this.startPage = 0;
          this.searchQuery = '';
        });
      this.loading = false;
      this.showEditForm = false;
    },
  },
};
</script>
<style scoped>
.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark>>>.v-list-item {
  color: #37474f !important;
}

.theme--dark.v-label {
  color: rgba(255, 255, 255, 0.7);
}

.theme--dark.v-messages {
  color: #37474f !important;
}

.hint-text {
  font-size: 13px;
  color: #444444;
  margin-top: -13px !important;
}
</style>
